const sbannerImg = {
  lua2012: require('./Banners/services/lua2012.jpg'),
  flt2012: require('./Banners/services/fleet.jpg'),
  log2012: require('./Banners/services/logistics.jpg'),
  oem2012: require('./Banners/services/oem4.JPG')
}
export default sbannerImg
